import { createReducer, on } from '@ngrx/store';
import {
    CATEGORY_FIND_SUCCESS,
    CATEGORY_FAILED,
    CATEGORY_UPDATE_LOADING
} from '../actions';
import { Category } from '@core/models';

export interface CategoryState {
  categoryList: Category[] | null;
  categoryId: string | null;
  error: string | null;
  loading: boolean;
}

const initialState: CategoryState = {
  categoryList: null,
  categoryId: null,
  error: null,
  loading: false,
};

export const categoryReducer = createReducer(
  initialState,
  on(CATEGORY_FIND_SUCCESS, (state, { categoryList }) => ({ ...state, categoryList })),
  on(CATEGORY_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(CATEGORY_FAILED, (state, { error }) => ({ ...state, error })),
);
